import { login, loginWithToken, logout, resetPassword, changePassword } from '../api';
import { dispatchErrorAction } from './index';
import { setAuthToken, removeAuthToken } from '../api/httpClient';
import NotificationsService from '../services/NotificationsService';
import UsersService from '../services/UsersService';
import { analyticsKeys } from '../constants/analytics';

import * as actionTypes from './actionTypes';

export function signIn (email, password) {
  return dispatch => login(email, password)
    .then(({ data }) => {
      setAuthToken(data.id);
      return dispatch(loginViaToken(data.id));
    }).catch(error => {
      dispatchErrorAction(error, dispatch, true);
    });
}

export function loginViaToken (token) {
  return dispatch => {
    if (!token) {
      return;
    }
    UsersService.startLoading();
    return loginWithToken(token)
      .then(data => {
        const user = data.data;
        UsersService.saveUser(user);
        UsersService.stopLoading();

        dispatch({ type: actionTypes.SIGN_IN, user });
        if (!NotificationsService.isSupported) {
          dispatch({
            type: actionTypes.UI_SHOW_ALERT,
            message: 'This browser does not support push notifications and dynamic messaging.\nPlease use another web browser for better experience.'
          });
        } else {
          NotificationsService.init(user.userid);
        }
        window.analytics.identify(user.userid, {
          name: user.first_name + ' ' + user.last_name,
          firstName: user.first_name,
          lastName: user.last_name,
          email: user.email,
          gravy_user_id: user.userid,
          last_app: 'webadmin'
        });
        let intercom_payload = {
          app_id: analyticsKeys.INTERCOM_KEY,
          user_id: user.userid,
          gravy_user_id: user.userid,
          name: `${user.first_name} ${user.last_name}`,
          email: user.email,
          last_app: 'webadmin'
        };
        window.Intercom('boot', intercom_payload);
        return user;
      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          removeAuthToken();
          return err.response.data;
        }
        dispatchErrorAction(err, dispatch);
        UsersService.stopLoading();
      });
  };
}

export function logOut () {
  if (NotificationsService.fcmToken) {
    try {
      NotificationsService.unsubscribe();
    } catch (error) {
      console.info(error);
    }
  }

  if (UsersService.isUserExists()) {
    UsersService.deleteUser();
  }

  return dispatch => logout()
    .then(() => {
      removeAuthToken();
      dispatch({ type: actionTypes.LOG_OUT });
      dispatch({ type: actionTypes.CLEAR_CONVERSATIONS_HISTORY });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function forgotPassword (formData) {
  return dispatch => resetPassword(formData)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function changePasswordAction (data) {
  return dispatch => changePassword(data)
    .then(({ data }) => data)
    .catch(error => dispatchErrorAction(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/auth.js